import { render } from "./FeaturedVideo.vue?vue&type=template&id=196a7ce7&scoped=true"
import script from "./FeaturedVideo.vue?vue&type=script&lang=js"
export * from "./FeaturedVideo.vue?vue&type=script&lang=js"

import "./FeaturedVideo.vue?vue&type=style&index=0&id=196a7ce7&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196a7ce7"]])

export default __exports__